import { render, staticRenderFns } from "./build_list.vue?vue&type=template&id=63ac9302&scoped=true&"
import script from "./build_list.vue?vue&type=script&lang=js&"
export * from "./build_list.vue?vue&type=script&lang=js&"
import style0 from "./build_list.vue?vue&type=style&index=0&id=63ac9302&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ac9302",
  null
  
)

export default component.exports